import { render, staticRenderFns } from "./hotelsBlock.vue?vue&type=template&id=cb07ae30&scoped=true&"
import script from "./hotelsBlock.vue?vue&type=script&lang=js&"
export * from "./hotelsBlock.vue?vue&type=script&lang=js&"
import style0 from "./hotelsBlock.vue?vue&type=style&index=0&id=cb07ae30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb07ae30",
  null
  
)

export default component.exports